import React from 'react';
import {moment} from 'helpers';
import {Flex, Button} from 'components';
import {Announcement} from './announcement';
import {RootState, session} from 'store';

// Version 2
export class CoachingOffer2 extends Announcement {
  eligible(state: RootState) {
    const lastViewed = state.settings.announcements?.[this.constructor.name];
    const {premium} = session.subscription(state);
    if (lastViewed === -1 || !premium) {
      return false;
    }
    return !lastViewed || moment().diff(moment.unix(lastViewed), 'days') > 6;
  }

  render() {
    return (
      <div>
        <h1>Special Bonus</h1>
        <p>Congratulations! You are eligible to a <b>Discounted 1:1 Personal Coaching</b> session to help you gain Clarity, stay Focused, and get your desired Results.</p>
        <br />
        <Flex className={['spacing']}>
          <Button onClick={this.props.decline} className="subtle">Decline</Button>
          <Button onClick={this.props.next} className={['pull-right', 'subtle']}>Remind later</Button>
          <Button onClick={this.props.next} target="_blank" href="https://successwizard.thrivecart.com/personal-coaching-session-1/?coupon=CO70" className={['primary', 'filled']}>Learn more</Button>
        </Flex>
      </div>
    );
  }
};
